import orderNumber from './order-number';
import shipFrom from './ship-from';
import deductInventory from './deduct-inventory';
import carrier from './carrier';
import trackingNumber from './tracking-number';
import shipDate from './ship-date';
import notifyCustomer from './notify-customer';
import notifyMarketplace from './notify-marketplace';
import recipient from './recipient';

const primaryColumns = [orderNumber, carrier, trackingNumber, shipDate, notifyCustomer, notifyMarketplace, recipient];

const inventoryColumns = [shipFrom, deductInventory];

const getColumns = (shouldIncludeInventory, shouldForceShipFrom) => {
  const columnsToRender = [...primaryColumns];
  if (shouldIncludeInventory) {
    columnsToRender.push(...inventoryColumns);
  } else if (shouldForceShipFrom) {
    columnsToRender.push(shipFrom);
  }
  return columnsToRender;
};

export default getColumns;
